import React, { useContext, useState, useEffect } from "react";
import NavBar from "../Admin/Dashboard/NavBar";
import ReactProSidebar from "../Admin/Dashboard/ReactProSidebar";


import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CircularProgress from "@mui/material/CircularProgress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jwtDecode } from "jwt-decode";
import { generateHash } from "../../API/hashUtil";
import nodata from "../../images/nodata2.png";
import { downloadReportPdf } from "./Reportpdfdownload"
import {
  Box,
  Typography,
  Chip,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
  Skeleton,
} from "@mui/material";
import { faStarOfLife } from "@fortawesome/free-solid-svg-icons";
import {
  faSquareFacebook,
  faYoutube,
  faInstagram,
  faTiktok,
  faSquareXTwitter,
  faSquareThreads,
  faGolang,
  faThreads,
  faReddit,
  faPinterest,
  faQuora 
} from "@fortawesome/free-brands-svg-icons"; // Import the icons

import { MyContext } from "../../MyContextApi";
import { toast } from "react-toastify";
import {
  formatDateTime,
  formatDateTimeCombined,
} from "./Helpers/DateTimeHelper";
import { handleSentimentSummary } from "../../API/SentimentSummary";
import api from "../../API/axiosInstance";
import { useAuth } from "../../context/AuthContext";



export default function DownloadHistory() {
  const [downloadedData, setdownloadedData] = useState([]);
  const [clearParams, setclearParams] = useState(false);
  const [loadingStates, setLoadingStates] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const {
    reporttoDateTimeFormatted,
    setreportToDateTimeFormatted,
    reportfromDateTimeFormatted,
    setreportFromDateTimeFormatted,
    apiSelect,
    setAPISelect,
    selectedPlatforms,
    setSelectedPlatforms,
    isDownload,
    setIsDownload,
    serverresponse,
    selectedRange,
    setSelectedRange,
    setServerResponse,
    setResponseCount,
    setNewsCount,
    setpdfToSimple,
    setsentimentSummary,
  } = useContext(MyContext);

  // const token = localStorage.getItem("Token");

  // const decodedToken = jwtDecode(token);
  // const userRole = decodedToken.role[0];


  const { user, role: userRole, logout: authLogout } = useAuth();

  const userName = user?.username || "";



  let stringParams = "";

  useEffect(() => {
    handleDownloadHistory();
  }, []);






  function handleDownloadHistory() {
    api
      .get(`/user/reportDetails`, {
        headers: {
          // Security Headers
          "X-XSS-Protection": "1; mode=block",
          "X-Content-Type-Options": "nosniff",
          "X-Frame-Options": "DENY",
          "Referrer-Policy": "strict-origin-when-cross-origin",
          "Permissions-Policy": "camera=(), microphone=(), geolocation=()",
          // Standard Headers
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setdownloadedData(res.data);
        setLoading(false); // ✅ Set loading to false after fetching data
      })
      .catch((err) => {
        console.error("Error fetching report details:", err);
        setTimeout(() => {
          setLoading(false);
        }, 0); // Set a delay of 0 to ensure execution
      });
  }



  const handleDownloadButtonClicked = async (
    reportType,
    platform,
    startDate,
    endDate,
    index,
    date
  ) => {
    setLoadingStates((prevState) => ({ ...prevState, [index]: true }));

    const formattedToDateTime = dayjs(endDate).format("YYYY-MM-DDTHH:mm:ss[Z]");
    const formattedFromDateTime = dayjs(startDate).format("YYYY-MM-DDTHH:mm:ss[Z]");

    // Map reportType string to the apiSelect object format that downloadReportPdf expects
    const apiSelectObj =
      reportType === "Social Media Report"
        ? { value: "api/filter", label: "Social Media Report" }
        : reportType === "Sentiment Report"
          ? { value: "api/socialSentiments", label: "Sentiment Report" }
          : reportType === "News Report"
            ? { value: "news/report", label: "News Report" }
            : { value: "analysis/imageData", label: "Image Report" };

    // Convert platform array to the format downloadReportPdf expects
    // (array of objects with value property)
    const platformObjects = platform.map((p) => ({ value: p }));

    try {
      await downloadReportPdf({
        apiSelect: apiSelectObj,
        reportfromDateTimeFormatted: formattedFromDateTime,
        reporttoDateTimeFormatted: formattedToDateTime,
        selectedPlatforms: platformObjects,
        selectedSections: [],
        selectedLanguages: [],
        selectedSentiment: [],
        selectedIntensity: [],
        selectedContent: [],
        selectedKeyword: [],
        onStart: () => {

          toast.info("Download started...");
        },
        onSuccess: () => toast.success("Report downloaded successfully!"),
        onError: (err) => toast.error(err.message),
      });
    } catch (error) {
      console.error("Error downloading report:", error);
      toast.error("Failed to download report.");
    } finally {
      setLoadingStates((prevState) => ({ ...prevState, [index]: false }));
    }
  };




  const getPlatformIcon = (platform) => {
    const normalizedPlatform = platform?.toLowerCase();

    switch (normalizedPlatform) {
      case "twitter":
      case "x":
        return (
          <FontAwesomeIcon
            icon={faSquareXTwitter}
            style={{
              color: "black",
              fontSize: "21px",
            }}
          />
        );

      case "youtube":
        return (
          <FontAwesomeIcon
            icon={faYoutube}
            style={{
              color: "red",
              fontSize: "21px",
            }}
          />
        );

      case "facebook":
        return (
          <FontAwesomeIcon
            icon={faSquareFacebook}
            style={{
              color: "blue",
              fontSize: "21px",
            }}
          />
        );

      case "quora":
        return (
          <FontAwesomeIcon
            icon={faQuora}
            style={{
              color: "#B92B27",
              fontSize: "21px",
            }}
          />
        );

      case "threads":
        return (
          <FontAwesomeIcon
            icon={faSquareThreads}
            style={{
              color: "black",
              fontSize: "21px",
            }}
          />
        );

      case "reddit":
        return (
          <FontAwesomeIcon
            icon={faReddit}
            style={{
              color: "red",
              fontSize: "21px",
            }}
          />
        );

      case "pinterest":
        return (
          <FontAwesomeIcon
            icon={faPinterest}
            style={{
              color: "#E60023",
              fontSize: "21px",
            }}
          />
        );

      case "all":
        return (
          <FontAwesomeIcon
            icon={faStarOfLife}
            style={{
              color: "#615EFC",
              fontSize: "21px",
            }}
          />
        );

      default:
        return null;
    }
  };





  const getPlatformStyle = (platform) => {
    return { backgroundColor: "#ffffff" };
  };


  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value.toLowerCase());
  };


  const filteredData = downloadedData.filter(
    (item) =>
      item.username?.trim() &&
      item.startDate &&
      item.endDate !== null &&
      item.username
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
  );


  const SkeletonLoader = () =>
    Array(3)
      .fill(0)
      .map((_, index) => (
        <Card
          key={index}
          sx={{
            mb: 3,
            borderRadius: 2,
            boxShadow: 2,
            backgroundColor: "#fff",
            padding: 2,
          }}
        >
          <CardContent>
            <Grid container sx={{ mb: 2 }}>
              <Grid item xs={1}>
                <Skeleton width={30} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton width={100} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton width={120} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton width={150} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton width={100} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton width={120} />
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={1}>
                <Skeleton width={20} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton width={80} />
              </Grid>
              <Grid item xs={2}>
                <Skeleton width={100} height={40} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton width={120} height={32} />
              </Grid>
              <Grid item xs={2}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Skeleton width={40} height={32} />
                  <Skeleton width={40} height={32} />
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Skeleton width={150} />
              </Grid>
              <Grid item xs={12} sx={{ mt: 2, textAlign: "right" }}>
                <Skeleton width={100} height={36} sx={{ ml: "auto" }} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      ));



  return (
    <div className="container">
      <NavBar />

      <main className="session-main">
        <Box sx={{ p: 3, backgroundColor: "#f4f6f8", minHeight: "100vh" }}>
          {/* Page Heading */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            {/* Download History Heading */}
            <div style={{ textAlign: "left" }} className="basic-Header">
              Download History
            </div>

            {/* Search Field */}

            {userRole === "ROLE_ADMIN" && (
              <TextField
                label="Search by Username"
                variant="outlined"
                size="small"
                onChange={handleSearchChange}
                value={searchQuery}
                sx={{
                  backgroundColor: "#fff",
                  width: "300px",
                  fontWeight: "400",
                  fontFamily: "'Host Grotesk', sans-serif",
                  borderRadius: "8px",
                }}
              />
            )}
          </Box>

          {loading ? (
            <SkeletonLoader />
          ) : filteredData && filteredData.length > 0 ? (
            filteredData
              .sort((a, b) => new Date(b.date) - new Date(a.date))
              .map((item, index) => (
                <Card
                  key={index}
                  sx={{
                    mb: 3,
                    borderRadius: 5,
                    boxShadow: 2,
                    backgroundColor: "#fff",
                    padding: 2,
                    color: "#333",
                  }}
                >
                  <CardContent>
                    {/* Header Section */}
                    <Grid
                      container
                      sx={{
                        backgroundColor: "#f0f0f0",
                        borderRadius: 3,
                        p: 1,
                        mb: 2,
                        width: "100%",
                      }}
                    >
                      <Grid item xs={1}>
                        <Typography
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                            color: "#6c757d",
                          }}
                        >
                          S.No
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                            color: "#6c757d",
                          }}
                        >
                          Username
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                            color: "#6c757d",
                          }}
                        >
                          Date
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                            color: "#6c757d",
                          }}
                        >
                          Report Type
                        </Typography>
                      </Grid>

                      {item.reportType === "Social Media Report" && (
                        <Grid item xs={2}>
                          <Typography
                            sx={{
                              fontWeight: "400",
                              fontFamily: "'Host Grotesk', sans-serif",
                              color: "#6c757d",
                            }}
                          >
                            Platforms
                          </Typography>
                        </Grid>
                      )}

                      <Grid item xs={2}>
                        <Typography
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                            color: "#6c757d",
                          }}
                        >
                          Time Range
                        </Typography>
                      </Grid>
                    </Grid>

                    {/* Data Section */}
                    <Grid
                      container
                      alignItems="center"
                      sx={{ paddingLeft: "15px", paddingRight: "15px" }}
                    >
                      <Grid item xs={1}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                            color: "#0065F8",
                          }}
                        >
                          {index + 1}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                          }}
                        >
                          {item.username}
                        </Typography>
                      </Grid>

                      <Grid item xs={2}>
                        {(() => {
                          const { formattedDate, formattedTime } =
                            formatDateTime(item.date);
                          return (
                            <>
                              {/* Display the date on the first line */}
                              <Typography
                                variant="body1"
                                sx={{
                                  fontWeight: "400",
                                  fontFamily: "'Host Grotesk', sans-serif",
                                }}
                              >
                                {formattedDate}
                              </Typography>
                              {/* Display the time on the second line */}
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: "400",
                                  fontFamily: "'Host Grotesk', sans-serif",
                                }}
                              >
                                {formattedTime}
                              </Typography>
                            </>
                          );
                        })()}
                      </Grid>

                      <Grid item xs={3}>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          <Chip
                            label={item.reportType}
                            sx={{
                              fontSize: "0.85rem",
                              backgroundColor: "#e3f2fd",
                              color: "#1976d2",

                              fontWeight: "400",
                              fontFamily: "'Host Grotesk', sans-serif",
                            }}
                          />
                        </Box>
                      </Grid>

                      {item.reportType === "Social Media Report" && (
                        <Grid item xs={2}>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "10px",
                            }}
                          >
                            {item.platform.map((platform, i) => (
                              <Chip
                                key={i}
                                icon={null} // We will render the icon manually
                                label={
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "100%",
                                      height: "100%",
                                    }}
                                  >
                                    {getPlatformIcon(platform)}
                                  </Box>
                                }
                                sx={{
                                  fontSize: "0.85rem",
                                  ...getPlatformStyle(platform),
                                  color: "#fff",

                                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                                  // minWidth: "40px", // optional: ensure square/round look
                                  // height: "40px", // optional: make it look like a button
                                  // borderRadius: "40%", // optional: make it circular
                                }}
                              />
                            ))}
                          </Box>
                        </Grid>
                      )}

                      <Grid item xs={2}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: "400",
                            fontFamily: "'Host Grotesk', sans-serif",
                          }}
                        >
                          {`${formatDateTimeCombined(
                            item.startDate
                          )} to ${formatDateTimeCombined(item.endDate)}`}
                        </Typography>
                      </Grid>

                      {/* Download Button */}
                      <Grid item xs={12} sx={{ mt: 2, textAlign: "right" }}>
                        <Button
                          onClick={() =>
                            handleDownloadButtonClicked(
                              item.reportType,
                              item.platform,
                              item.startDate,
                              item.endDate,
                              index,
                              item.date
                            )
                          }
                          variant="contained"
                          color="primary"
                          size="small"
                          disabled={loadingStates[index]}
                          sx={{
                            minHeight: "36px",
                            padding: "8px 16px",
                            margin: "0 6px",
                            borderRadius: "24px", // Fully rounded for chip look
                            textTransform: "none",
                            fontWeight: "600", // Using active state weight since it's a primary action
                            fontSize: "15px",
                            fontFamily: "'Host Grotesk', sans-serif",
                            border: "none",
                            backgroundColor: "#615EFC",
                            color: "white",
                            boxShadow: "0 3px 8px rgba(97, 94, 252, 0.3)",
                            transition: "all 0.2s ease",
                            cursor: "pointer",
                            "&:hover": {
                              backgroundColor: "#524BF0",
                              color: "white",
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 16px rgba(97, 94, 252, 0.4)",
                            },
                            "&:active": {
                              transform: "translateY(-1px)",
                              boxShadow: "0 2px 6px rgba(97, 94, 252, 0.3)",
                            },
                            "&:disabled": {
                              backgroundColor: "#e8e8e8",
                              color: "#666",
                              transform: "none",
                              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                            },
                          }}
                        >
                          {loadingStates[index] ? (
                            <CircularProgress
                              size={20}
                              sx={{ color: "white" }}
                            />
                          ) : (
                            "Download"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              ))
          ) : (
            <div
              style={{
                width: "160vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="No Data"
                src={nodata}
                style={{
                  width: "75vh",
                }}
              />
            </div>
          )}
        </Box>
      </main>

      <ReactProSidebar />
    </div>
  );


}
